<div class="default-overlay-wrapper">
  @if (!isLoading) {
    <ng-scrollbar class="std-scrollbar" orientation="vertical" appearance="native">
      @let data = overlayService.data$ | async;
      @if (isArray(data)) {
        @for (item of  data; track item; let i = $index) {
          <div
            aria-hidden="true"
            (click)="selectItem(item)"
            class="item"
            [class.keyboardSelection]="overlayService.keyboardSelectionIsActive && overlayService.keyboardSelection === i"
          >
            {{ item.name }}
          </div>
        }
      }
    </ng-scrollbar>
  }
  @if (isLoading) {
    <div class="h-100 flex justify-center items-center">
      <span class="icon-refresh animate-spin text-size_title_xl text-navy-600"></span>
    </div>
  }
</div>
